import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { UnitCardContainer, UnitCardIconContainer } from './styles';
import { Button } from 'components';
import * as icons from 'icons';
import { IconNames } from '../../types';
import { colors } from 'styles/colors';

interface UnitCardProps {
  cardColor: string;
  icon: {
    name: IconNames;
    color: string;
    size?: number;
  }
  description: string;
  value: number | undefined;
  onClickDetails: (() => void) | undefined;
}

interface UnitCardIconProps {
  color: string;
  icon: IconNames;
  disabled: boolean;
  size?: number;
}

export function UnitCard({
  cardColor,
  description,
  icon,
  onClickDetails,
  value,
}: Readonly<UnitCardProps>): ReactElement {
  const { t } = useTranslation();
  const disabled = value === undefined;

  return (
    <UnitCardContainer
      backgroundColor={cardColor}
      disabledCard={disabled}
    >
      <UnitCardIcon
        disabled={disabled}
        icon={icon.name}
        color={icon.color}
        size={icon.size}
      />
      <h5>{value ?? '-'}</h5>
      <h6>{description}</h6>
      {!disabled && onClickDetails !== undefined && (
        <Button
          onClick={onClickDetails}
          type="button"
          variant="primary-ghost"
          style={{ width: 105 }}
        >
          {t('verDetalhes')}
        </Button>
      )}
    </UnitCardContainer>
  );
}

function UnitCardIcon({
  color,
  disabled,
  icon,
  size,
}: Readonly<UnitCardIconProps>): ReactElement {
  const Icon = icons[icon];

  return (
    <UnitCardIconContainer
      backgroundColor={color}
      disabled={disabled}
    >
      <Icon
        color={colors.icon['white-0']}
        size={size ?? 22}
      />
    </UnitCardIconContainer>
  );
}
